import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title:
    "ILO identifies the root cause\nbased on a model trained on\nhistorical data",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">Fast resolution time</span> — ensuring efficient and\ntimely issue resolution for an enhanced user\nexperience.',
  label: { iconPath: "start.png", text: "ILO AI" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_211"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_209"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 7_R1.mp4",
  pageNumber: "ILO_210",
};

export default DATA_NO_DEMO_ILO2;
